module.exports = __webpack_public_path__ + "static/media/poster.60546699.png";